import { render, staticRenderFns } from "./Telekonsultasi.vue?vue&type=template&id=a6ed7a04&"
import script from "./Telekonsultasi.vue?vue&type=script&lang=js&"
export * from "./Telekonsultasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports